import {
  SET_RECRUITERS_LIST,
  SET_RECRUITERS_LIST_LOADING,
  SET_CURRENT_RECRUITER,
  SET_LOADING_CURRENT_RECRUITER,
  SET_OTHER_TENANT_RECRUITERS,
} from "./recruitersConstants";
import { RecruitersService } from "../../services";

export const setRecruitersList = (results) => ({
  type: SET_RECRUITERS_LIST,
  payload: results,
});

export const setRecruitersListLoading = (isLoading) => ({
  type: SET_RECRUITERS_LIST_LOADING,
  payload: isLoading,
});

export const setCurrentRecruiter = (recruiter) => ({
  type: SET_CURRENT_RECRUITER,
  payload: recruiter,
});

export const setLoadingCurrentRecruiter = (isLoading) => ({
  type: SET_LOADING_CURRENT_RECRUITER,
  payload: isLoading,
});

export const setOtherTenantRecruiters = (results) => ({
  type: SET_OTHER_TENANT_RECRUITERS,
  payload: results,
});

export const fetchAndSetRecruitersList = (excludeSlug = null) => {
  return async (dispatch) => {
    dispatch(setRecruitersListLoading(true));

    try {
      const response = await RecruitersService.fetchRecruitersList(excludeSlug);

      if (response.status === 200 && response.data.status === 0) {
        dispatch(setRecruitersList(response.data.results));
      } else {
        dispatch(setRecruitersList([]));
      }
    } catch (e) {
      dispatch(setRecruitersList([]));
    }
  };
};

export const fetchAndSetCurrentRecruiter = (slug, {showLoading = true} = {}) => {
  return async (dispatch) => {
    if (showLoading) {
      dispatch(setLoadingCurrentRecruiter(true));
    }

    try {
      const response = await RecruitersService.fetchRecruiterProfile(slug);

      if (response.status === 200 && response.data.status === 0) {
        dispatch(setCurrentRecruiter(response.data.result));
      } else {
        dispatch(setCurrentRecruiter({ notFound: true }));
      }
    } catch (e) {
      dispatch(setCurrentRecruiter({ notFound: true }));
    }
  };
};

export const fetchAndSetOtherTenantRecruiters = (workplaceId, excludeSlug) => {
  return async (dispatch) => {
    try {
      const response = await RecruitersService.fetchRecruitersList(excludeSlug, workplaceId);

      if (response.status === 200 && response.data.status === 0) {
        dispatch(setOtherTenantRecruiters(response.data.results));
      } else {
        dispatch(setOtherTenantRecruiters([]));
      }
    } catch (e) {
      dispatch(setOtherTenantRecruiters([]));
    }
  };
};
